import {useLocation} from 'react-router';

export default function useHDNParameters() {
  const searchParams = new URLSearchParams(useLocation().search);
  const hdnKeys = Array.from(searchParams.keys()).filter(key => (/^hdn_/i).test(key));

  return hdnKeys.reduce((acc, key) => ({...acc, [key]: searchParams.get(key)}), {});
}
